/* eslint-disable no-param-reassign */

/**
 * Remove class helper method
 * @param {DOMelement} el - the element to remove a class from
 * @param {String} className - the class to remove
 * @return {DOMelement} el the original element
 */
var removeClass = function removeClass(element, className) {
  if (element === null) {
    return element;
  }

  if (element.classList) {
    element.classList.remove(className);
  } else {
    var regex = new RegExp("(^|\\b)".concat(className.split('·').join('|'), "(\\b|$)"), 'gi');
    element.className = element.className.replace(regex, ' ');
  }

  return element;
};

export default removeClass;